export default __webpack_public_path__ + "static/media/Sam Liccardo.f53a8f39.jpg";